module.exports = __webpack_public_path__ + "static/img/robotImg.cea1a467.png";